/* list of indices to access meeting's fields. */
export const idKey = 0;
export const dateKey = 2;
export const durationKey = 3;
export const titleKey = 4
export const transcriptionKey = 5;
export const summaryKey = 6
export const keypointsKey = 7
export const isSummarizedKey = 8
//export const transcribed_until = 9; unused in the frontend
export const pinedKey = 10;
